import { Component, input, output } from '@angular/core';
import { Document } from '@app/core/stingray-api/models';
import { TranslateModule } from '@ngx-translate/core';
import { MatLine } from '@angular/material/core';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { MatIconButton } from '@angular/material/button';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'unite-file-row',
    templateUrl: './file-row.component.html',
    styleUrls: ['./file-row.component.scss'],
    imports: [MatIconButton, MatTooltip, MatIcon, MatLine, TranslateModule, DatePipe]
})
export class FileRowComponent {

  document = input<Document>();
  fileExtension = input<string>();
  linkText = input<string>();
  showDownloadBtn = input<boolean>(true);
  showEditBtn = input<boolean>(true);

  downloadDocument = output<Document>();
  openDocument = output<Document>();
  showEdit = output<Document>();

}
